import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.scss',
    standalone: false
})
  
export class LogoComponent {
  
  host!: string;
  logo!: string;


  constructor() {
    this.host = environment.HOST;
    this.logo = environment.BRANDING_LOGO;
  }

}
